import * as actionTypes from '../action-types'

const initialState = {
  newPurpose: {
    purposeValidity: 'VALID',
    authCodeLm: 'authCodeLm',
    userName: 'string',
    userType: 'PRODUCT_MANAGER'
  },
  selectedPurpose: {},
  purposesList: [],
  purposeTableSort: {}
}

const reducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case actionTypes.UPDATE_NEW_PURPOSE:
      return {
        ...state,
        newPurpose: {
          ...state.newPurpose,
          ...payload
        }
      }
    case actionTypes.RESET_NEW_PURPOSE:
      return {
        ...state,
        newPurpose: initialState.newPurpose
      }
    case actionTypes.UPDATE_SELECTED_PURPOSE:
      return {
        ...state,
        selectedPurpose: {
          ...state.selectedPurpose,
          ...payload
        }
      }
    case actionTypes.RESET_SELECTED_PURPOSE:
      return {
        ...state,
        selectedPurpose: initialState.selectedPurpose
      }
    case actionTypes.UPDATE_PURPOSES_LIST:
      return {
        ...state,
        purposesList: payload
      }
    case actionTypes.UPDATE_PURPOSE_TABLE_SORT:
      return {
        ...state,
        purposeTableSort: payload
      }
    default:
      return state
  }
}

export default reducer


// WEBPACK FOOTER //
// ./src/redux-store/reducers/purpose-reducer.js